import React from 'react';
import PropTypes from 'prop-types';
import Link from '../../../shared/components/Link';
import Icon from '../../../shared/components/Icon';
import styles from './RecentSearches.scss';
import { RECENT_SEARCH_PROP_TYPES } from '../model/types';

const RecentSearches = ({ recentSearches = [], trackRecentSearchClick, deleteRecentSearch }) => (
  recentSearches.length ?
    <div className={styles.container}>
      <h2 className={styles.heading}>Recent Searches</h2>
      <div className={styles.wrapper}>
        { recentSearches.map(({ name, detailText, url }) =>
          <div
            key={url}
            className={styles.item}
          >
            <Link
              className={styles.link}
              href={url}
              onClick={trackRecentSearchClick}
            >
              <p className={styles.title}>{name}</p>
              <p className={styles.detail}>{detailText}</p>
            </Link>
            <button
              className={styles.deleteButton}
              onClick={() => deleteRecentSearch(url)}
            >
              <Icon name="cross" />
            </button>
          </div>)}
      </div>
    </div>
    : null
);

RecentSearches.propTypes = {
  recentSearches: RECENT_SEARCH_PROP_TYPES,
  trackRecentSearchClick: PropTypes.func.isRequired,
  deleteRecentSearch: PropTypes.func.isRequired,
};

export default RecentSearches;
